import React from 'react';
import PropTypes from 'prop-types';
import { CardMedia } from '@material-ui/core';
import { ActionTile } from '../../../../../ActionTile';
import BrandingTile from './BrandingTile';
import { makeCss } from '../../../../../../../../knock-design-system';
import { BRANDING_TILES } from './constants';

const { LOGO } = BRANDING_TILES;

const useCss = makeCss({
  logoImage: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
});

const Logo = ({ logos, openImageDialog }) => {
  const css = useCss();

  const [{ url: logoUrl } = {}] = logos || [];

  return (
    <BrandingTile title={LOGO.TITLE}>
      <ActionTile
        actionText={LOGO.ACTION_TEXT}
        actionOnClick={openImageDialog}
        iconName="upload"
        subText={LOGO.SUBTEXT}
      >
        {logoUrl && (
          <CardMedia
            css={css.logoImage}
            component="img"
            image={logoUrl}
            alt="Logo"
          />
        )}
      </ActionTile>
    </BrandingTile>
  );
};

Logo.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      clUrl: PropTypes.string,
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  openImageDialog: PropTypes.func.isRequired,
};

export default Logo;
